<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ title() | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <app-currencies-typeahead
          [control]="currencyFormControl"
          [placeholder]="placeholder() | translate"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="!currencyFormControl.value"
      (click)="updateCurrency()"
    >
      {{ 'common.buttons.btnUpdate' | translate }}
    </button>
  </div>
</div>
